module.exports = __webpack_public_path__ + "img/sec1_03.008bf24f.png";